export default ({ request }) => ({
  expoSampleListApi(data = {}) {
    return request({
      url: '/digitalCenter/expo/sample/list',
      method: 'post',
      data,
    })
  },
  expoSampleDetailApi(data = {}) {
    return request({
      url: '/digitalCenter/expo/sample/detail',
      method: 'post',
      data,
    })
  },
  expoSampleAddApi(data = {}) {
    return request({
      url: '/digitalCenter/expo/sample/add',
      method: 'post',
      data,
    })
  },
  expoSampleSaveApi(data = {}) {
    return request({
      url: '/digitalCenter/expo/sample/save',
      method: 'post',
      data,
    })
  },
  expoSampleDelApi(data = {}) {
    return request({
      url: '/digitalCenter/expo/sample/del',
      method: 'post',
      data,
    })
  },
  expoSampleAuditApi(data = {}) {
    return request({
      url: '/digitalCenter/expo/sample/audit',
      method: 'post',
      data,
    })
  },
  expoSampleChooseListApi(data = {}) {
    return request({
      url: '/digitalCenter/expo/sample/choose/list',
      method: 'post',
      data,
    })
  },
  expoSampleChooseAddApi(data = {}) {
    return request({
      url: '/digitalCenter/expo/sample/choose/add',
      method: 'post',
      data,
    })
  },
  masterSamplePropertiesListApi(data = {}) {
    return request({
      url: '/digitalCenter/master/sample/properties/list',
      method: 'post',
      data,
    })
  },
})
